<template>
  <div style="background: #fafafa">
    <div class="order-subtitle" v-show="isWaitApproveOrder">
      您的订单已提交课题组审批人，请等待审批。
    </div>
    <div class="order-subtitle" v-show="orderDetail && orderDetail.status === 14">
      您的订单已提交技术审核，技术审核预计在<span
      v-if="new Date().getHours() >= 17 && new Date().getMinutes() >= 30"
    >明天</span
    >17:30完成
    </div>
    <div class="order-subtitle" v-show="orderDetail && orderDetail.status === 16">
      您的订单未通过技术审核，未通过原因：{{ orderDetail && orderDetail.remark }}
    </div>
    <div class="order-detail-container" v-if="orderDetail">
      <!--<div class="hd research-background-color">-->
      <!--<span class="icon icon-left navshare" @click="goBack"></span>-->
      <!--<span class="header_title">订单详情</span>-->
      <!--</div>-->
      <div
        class="order-detail-content"
        :style="{
          'padding-bottom': showPlaceHolder ? '85px' : '50px',
        }"
      >
        <!--收货地址-->
        <div class="order-content-block"
             :style="{ 'margin-top': isWaitApproveOrder ? '25px' : '0' }"
        >
          <!--        <img src="static/img/express.png" class="address-label">-->
          <div class="block-item" style="height: 81px">
            <div class="block-address">
              <i
                class="icon-font emkt-icon-didian research-font-color"
                style="font-size: 18px"
              ></i>
              <div class="item-detail">
                <span class="deep-text-color">{{
                    orderDetail.expressAddress || '无收货地址'
                  }}</span>
                <span class="light-text-color"
                >{{ orderDetail.expressName }}
                  {{ orderDetail.expressMobile }}</span
                >
              </div>
            </div>
            <slot name="addressOperation" v-bind="{orderDetail}"></slot>
          </div>
          <div class="full-split-line" v-if="lastExpressInfo && expressTrack.length > 0"></div>
          <!--        物流信息-->
          <div class="block-address" v-if="lastExpressInfo && expressTrack.length > 0">
            <svg t="1691040315076" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6515" width="16" height="16" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M770.24115 684.200623c-47.547529 0-86.080383 38.54103-86.080383 86.0998 0 47.557749 38.531832 86.098778 86.080383 86.098778 47.546507 0 86.079361-38.54103 86.079361-86.098778C856.319489 722.740631 817.787657 684.199601 770.24115 684.200623z" fill="#5878fa" p-id="6516"></path><path d="M933.255409 476.888655 856.319489 339.800399c-15.735058-18.968527-26.360335-34.43992-51.647617-34.43992L684.159745 305.360479 684.159745 202.039697c0-18.968527-15.467305-34.438898-34.431745-34.438898L98.814978 167.600798C79.850539 167.600798 64.383234 183.07117 64.383234 202.039697l0 516.598802c0 18.970571 15.467305 34.440942 34.431745 34.440942l68.661142 0C175.919521 693.748758 226.558467 647.81081 288.191617 647.81081S400.464735 693.748758 408.907114 753.079441l240.617517-0.034747c8.47406-59.325573 59.113006-105.233884 120.716519-105.233884 61.634172 0 112.272096 45.93897 120.715497 105.268631l34.229397 0C944.149461 753.079441 959.616766 737.60907 959.616766 718.639521c0 0 0-139.573653 0-172.199601C959.615745 513.814994 933.255409 476.888655 933.255409 476.888655zM718.592511 546.43992 718.592511 374.240319l84.229621 0c5.547178 0 13.249661 8.138858 13.249661 8.138858l72.493477 134.801118c6.42095 9.450028 13.383537 20.650667 13.383537 29.259625L718.592511 546.43992z" fill="#5878fa" p-id="6517"></path><path d="M288.191617 684.200623c-47.547529 0-86.080383 38.54103-86.080383 86.0998C202.112255 817.858172 240.64511 856.399202 288.191617 856.399202s86.080383-38.54103 86.080383-86.098778C374.272 722.740631 335.738124 684.199601 288.191617 684.200623z" fill="#5878fa" p-id="6518"></path></svg>
            <div class="item-detail" @click="$emit('goToExpressInfo')">
              <span class="express-opcode-color">{{lastExpressInfo.opcode}}</span>
              <div style="display: flex; align-items: center">
                <span class="express-text-color" style="position: relative">{{ lastExpressInfo.remark }}</span>
                <i class="icon-font emkt-icon-lujing" style="font-size: 5px; position: absolute; right: 30px"></i>
              </div>
              <span class="express-text-color">{{ lastExpressInfo.acceptTime }}</span>
            </div>
          </div>
        </div>
        <!--订单详情-->
        <div class="order-content-block">
          <div class="block-item" style="height: 35px">
            <span class="deep-text-color" :lines="undefined"
            >订单编号：{{ orderDetail.orderNo }}</span
            >
            <div
              class="copy-orderno light-text-color"
              :data-clipboard-text="orderDetail.orderNo"
              @click="copy"
              id="tag-copy"
            >
              复制
            </div>
          </div>
          <div class="full-split-line"></div>
          <!--商品信息-->
          <div v-for="(item, i) in orderDetail.itemList">
            <gc-order-product :item="item" :order="orderDetail" :show-product-contract-no="showProductContractNo"></gc-order-product>
            <div class="block-item light-text-color" style="height: 35px">
              <div style="display: flex; align-items: flex-start">
                <div class="return-btn research-font-color" v-if="(item.contractNo && item.contractNo.indexOf('GVAP') < 0) || !item.contractNo"
                  style="margin-right: 10px"
                  @click="$emit('goToProductInfo', item)">产品详情
                </div>
                <div v-if="item.contractNo && item.contractNo.indexOf('GVAP') < 0"
                  class="return-btn research-font-color"
                  style="margin-right: 10px"
                  @click="$emit('goToProgressInfo', item)"
                >
                  进展查询
                </div>
<!--                <div class="return-btn research-font-color"-->
<!--                     style="margin-right: 10px"-->
<!--                     @click="$emit('getExpressSheet', item)">出货单-->
<!--                </div>-->
                <slot name="productOperations" v-bind="{item, orderDetail}"></slot>
              </div>
              <span class="research-font-color">¥ {{ emkt.formatPrice(item.price) }}</span>
            </div>
            <div class="split-line"/>
          </div>
          <!--价格信息-->
          <div class="block-item light-text-color" style="height: 30px">
            <span class="light-text-color">商品总额</span>
            <span class="research-font-color"
            >¥{{ emkt.formatPrice(orderDetail.initPrice) }}</span
            >
          </div>
          <div class="block-item light-text-color" style="height: 30px">
            <span class="light-text-color">优惠折扣</span>
            <span class="research-font-color"
            >- ¥{{ emkt.formatPrice(orderDetail.discountPrice) }}</span
            >
          </div>
          <div class="block-item light-text-color" style="height: 30px">
            <span class="light-text-color">运费</span>
            <span class="research-font-color"
            >¥{{ emkt.formatPrice(orderDetail.expressPrice) }}</span
            >
          </div>
          <div class="full-split-line"></div>
          <div class="block-item" style="height: 40px">
            <span class="light-text-color">共{{ itemListLength }}件商品</span>
            <div>
              <span class="light-text-color">合计</span>
              <span
                class="research-font-color bold-text"
                style="font-size: 16px"
              >¥{{ emkt.formatPrice(orderDetail.price) }}</span
              >
            </div>
          </div>
        </div>
        <!-- 结算支付方式-->
        <div class="order-content-block">
          <div class="block-item" style="height: 40px">
            <span class="deep-color">结算方式</span>
            <span class="light-text-color">{{ getBalanceTypeName() }}</span>
          </div>
          <div class="full-split-line"></div>
          <div class="block-item" style="height: 40px">
            <span class="deep-color">支付方式</span>
            <span class="light-text-color">{{ getPayTypeName() }}</span>
          </div>
          <div
            class="block-item"
            style="height: 40px"
            v-if="orderDetail.sfQuoteNo"
          >
            <span class="deep-color">报价编号</span>
            <span class="light-text-color">{{ orderDetail.sfQuoteNo }}</span>
          </div>
          <div class="full-split-line"></div>
          <div class="block-item" style="height: 40px">
            <span class="deep-color">配送方式</span>
            <span class="light-text-color">{{ getDeliverMethod() }}</span>
          </div>
          <div class="full-split-line"></div>
          <div class="block-item" style="height: 40px">
            <span class="deep-color">下单时间</span>
            <span class="light-text-color">{{ orderDetail.orderTime }}</span>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-content">
          <slot name="orderOperations" v-bind="{orderDetail}"></slot>
        </div>
        <gc-footer-placeholder :show-place-holder="showPlaceHolder"></gc-footer-placeholder>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

// import $ from 'jquery'
import Clipboard from 'clipboard'
import EMKT from '../../../constant'
import GcFooterPlaceholder from '../../../components/GcFooterPlaceholder.vue'
import GcOrderProduct from '../../product/components/GcOrderProductBase.vue'

export default {
  props: {
    orderDetail: Object,
    expressTrack: Array,
    showProductContractNo: Boolean,
    showPlaceHolder: Boolean
  },
  emits: ['goToProductInfo', 'goToProgressInfo', 'goToExpressInfo'],
  data () {
    return {
      status: 2,
      routeType: 1,
      showSampleDeliveryGuide: true,
      emkt: EMKT
    }
  },
  async created () {
    console.log('this.orderDetail===============>', this.orderDetail)
  },
  components: { GcFooterPlaceholder, GcOrderProduct },
  computed: {
    lastExpressInfo () {
      console.log('this.expressTrack===============>', this.expressTrack)
      let lastExpressInfo = {
        acceptTime: "1900-01-01 00:00:00",
        opcode: "",
        remark: "快递信息已经超过三个月"
      }
      if (this.expressTrack) {
        for (let i = 0; i < this.expressTrack.length; i++) {
          let routes = this.expressTrack[i].routes
          if (routes) {
            for (let j = 0; j < routes.length; j++) {
              let maxDateTime = new Date(lastExpressInfo.acceptTime)
              let currentDateTime = new Date(routes[j].acceptTime)
              if (currentDateTime.getTime() > maxDateTime.getTime()) {
                lastExpressInfo = routes[j]
              }
            }
          }
        }
      }
      console.log('lastExpressInfo===============>', lastExpressInfo)
      return lastExpressInfo
    },
    itemListLength () {
      let num = 0
      if (this.orderDetail.itemList) {
        for (let i = 0; i < this.orderDetail.itemList.length; i++) {
          let item = this.orderDetail.itemList[i]
          if (item.productType === '服务类') {
            if (item.contractNoSrc === '') {
              num++
            }
          } else {
            num++
          }
        }
      }
      return num
    },
    // 商品总额
    discountPrice: function () {
      if (this.orderDetail) {
        let discountPrice =
          (this.orderDetail.discountPrice + '').replace('-', '') - 0
        return discountPrice
      } else {
        return 0
      }
    },
    isWaitApproveOrder () {
      if (!this.orderDetail) return false
      return (
        this.orderDetail.status === EMKT.ORDER_STATUS_SUBMITTED &&
        this.orderDetail.approveResult ===
        EMKT.RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE
      )
    },
    showPdf () {
      if (!this.orderDetail) return false
      return (EMKT.ORDER_STATUS_FINISHED !== this.orderDetail.status)
    },
  },
  methods: {
    stringSet (str) {
      if (str) {
        let temp = str.replace(/&nbsp;/gi, ' ')
        return temp
      } else {
        return ''
      }
    },
    copy () {
      const clipboard = new Clipboard('#tag-copy')
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', (e) => {
        this.$weui.toast('复制成功', 1500)
        // $.toast('复制成功')
        clipboard.destroy() // 释放内存
      })
      clipboard.on('error', (e) => {
        this.$weui.topTips('该浏览器不支持自动复制')
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    // goMessage () {
    //   window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    // },
    getStatusStyle: EMKT.getStatusStyle,
    getOrderStatusText: EMKT.getOrderStatusText,
    getBalanceTypeName () {
      if (!this.orderDetail) return ''
      return this.orderDetail.balanceType === EMKT.BALANCE_TYPE_CUSTOMER
        ? '个人结算'
        : this.orderDetail.researchGroupName
    },
    getPayTypeName () {
      if (!this.orderDetail) return ''
      return this.orderDetail.payType === EMKT.PAY_TYPE_FAPIAO
        ? '发票支付'
        : '余额支付'
    },
    getDeliverMethod () {
      if (!this.orderDetail) return ''
      return this.orderDetail.expressFree ? '不发货' : '顺丰快递'
    }
  },
}
</script>

<style scoped>
.pay-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 23px;
  color: #fff;
  text-align: center;
  font-size: 12px;
}

.cancel-btn {
  width: 73px;
  height: 26px;
  border-radius: 44px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
  margin-right: 10px;
}

.submit-btn {
  width: 73px;
  height: 26px;
  border-radius: 44px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  margin-right: 10px;
}

.product-label {
  z-index: 5;
  width: 30px;
  position: absolute;
  top: 0;
  left: -15px;
}

.address-label {
  width: 34px;
  position: absolute;
  top: 0;
  left: 0;
  height: 34px;
  z-index: 5;
}

.order-detail-container {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
  position: relative;
  /*background-color: #FAFAFA;*/
  padding: 0 10px;
  padding-bottom: 0;
  background: #fafafa;
}

.order-subtitle {
  padding: 0 15px;
  margin-bottom: 10px;
  background-color: #fe654d;
  line-height: 25px;
  font-size: 12px;
  color: #fff;
  width: 100%;
  z-index: 10;
}

.order-content-block {
  position: relative;
  margin-top: 0;
  margin-bottom: 10px;
  padding: 0 15px;
  border-radius: 10px;
  width: 100%;
  border: 0.5px solid #efeef3;
  background-color: #fff;
}

.copy-orderno {
  width: 42px;
  height: 23px;
  line-height: 21px;
  text-align: center;
  border-radius: 44px;
  border: 1px solid rgba(151, 151, 151, 1);
}

.small-font {
  font-size: 12px;
  transform: scale(0.8);
  transform-origin: left center;
}

.block-address {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 90%;
  margin-top: 10px
}

.item-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
  margin-right: 30px;
  width: 75%;
}


row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}

.return-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 21px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
}

.deep-text-color {
  color: #424242;
  font-size: 12px;
  font-weight: bold;
}

.express-opcode-color {
  color: #2BA471;
  font-size: 12px;
  font-weight: bold;
}

.express-text-color {
  color: #2BA471;
  font-size: 10px;
}

.deep-color {
  color: #424242;
  font-size: 12px;
}

.tiny-font {
  font-size: 12px;
  transform: scale(0.8);
  transform-origin: left center;
}

.block-item {
  /*height: 35px;*/
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  flex-shrink: 0;
}

.split-line {
  border-top: 0.5px solid #efeef3;
  margin-right: -15px;
  height: 1px;
}

.full-split-line {
  border-top: 0.5px solid #efeef3;
  margin-right: -15px;
  margin-left: -15px;
  height: 1px;
}

.bold-text {
  font-weight: bold;
}

.light-text-color {
  color: #929292;
  font-size: 12px;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #fff;
  z-index: 10;
}

.footer-content {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 10px;
  position: relative;
  flex-wrap: wrap;
}


.largeIcon {
  position: relative;
  margin-right: 1.33vw;
  width: 13.87vw;
  height: 13.87vw;
}


.tabbarserviceselWrap {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-right: 2.4vw;
  width: 12.53vw;
  height: 12.53vw;
}

.iconTest {
  position: absolute;
  top: 0;
  left: 0;
  width: 12.53vw;
  height: 12.53vw;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// GcOrderDetailBase.vue?5a164b12